export const FADE_TIME = 500;
